// import { useAuth } from "../context/LoginContext";
import { toast } from "react-toastify";
import { useApiRequest } from "../helper/api";
import { UserInfoModel, userPayload1 } from "../model/userModel";

const useAuthApi = () => {
  const { fetchTokenData } = useApiRequest();

  // const { logout } = useAuth();

  // const fetchGetToken1 = async (payload: userPayload): Promise<UserInfoModel | null> => {
  //   const response = await fetchTokenData("/user/get_token", {
  //     method: "POST",
  //     data: payload,
  //   });
  //   console.log('token', response)
  //   if (response?.status) {
  //     // return response.data;
  //   }
  //   return null;
  // };

  const fetchGetToken1 = async (payload: userPayload1): Promise<UserInfoModel | null> => {
    const response = await fetchTokenData("/user/checkuser", {
      method: "POST",
      data: payload,
    });
    console.log("token", response);
    if (response?.status) {
      if (typeof response.data === "string") {
        toast.error(response?.data);
        return null
      }
      return response.data;
    }
    return null;
  };

  return {
    // fetchGetToken,
    fetchGetToken1,
  };
};

export default useAuthApi;
